import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject, forkJoin } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MeterAbstractService } from '../../services/meter.abstract.service';

@Component({
    selector: 'app-meter-list',
    templateUrl: './meter-list.component.html',
    styleUrls: ['./meter-list.component.scss'],
})
export class MeterListComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    selectedTab = 'inventory';

    inventoryCount = 0;
    alertCount = 0;
    unassignedCount = 0;
    healthCount = 0;

    subTabs: { id: string; translationKey: string; count: () => number }[] = [
        { id: 'inventory', translationKey: 'meter.manage.tab_inventory', count: () => this.inventoryCount },
        { id: 'alerts', translationKey: 'meter.manage.tab_alerts', count: () => this.alertCount },
        { id: 'unassigned', translationKey: 'meter.manage.tab_unassigned', count: () => this.unassignedCount },
        { id: 'health', translationKey: 'meter.manage.tab_health', count: () => this.healthCount },
    ];

    constructor(private meterService: MeterAbstractService) {}

    ngOnInit(): void {
        this.loadCounts();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onSubTabChange(tabId: string): void {
        this.selectedTab = tabId;
    }

    private loadCounts(): void {
        forkJoin({
            inventory: this.meterService.getMeters({ page: 1, limit: 1 }),
            alerts: this.meterService.getAlerts({ page: 1, limit: 1, resolved: false }),
            unassigned: this.meterService.getUnassigned(1, 1),
            health: this.meterService.getHealth({ page: 1, limit: 1, silentDays: 7 }),
        })
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (result) => {
                    this.inventoryCount = result.inventory.total;
                    this.alertCount = result.alerts.total;
                    this.unassignedCount = result.unassigned.total;
                    this.healthCount = result.health.total;
                },
            });
    }
}
